import {
  ListDeliveredNotifications,
  ListDeliveredNotificationsVariables
} from './__generated__/ListDeliveredNotifications'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListDeliveredNotifications($id: String!, $cursor: String, $limit: Int) {
    scheduledNotification: scheduledNotificationV2(id: $id) {
      ... on ScheduledNotificationErrorV2 {
        type
        error
      }
      ... on ScheduledNotificationV2 {
        id
        listNotifications(input: { cursor: $cursor, limit: $limit }) {
          notifications {
            id
            personId
          }
          nextCursor
        }
      }
    }
  }
`

export const useListDeliveredNotifications = (variables: ListDeliveredNotificationsVariables) => {
  return useQuery<ListDeliveredNotifications, ListDeliveredNotificationsVariables>(QUERY, {
    variables
  })
}

useListDeliveredNotifications.QUERY = QUERY
